import { queryStringToObject } from './querystring'

const DEFAULT_IFRAME_TIMEOUT_MS = 6000
const POLL_INTERVAL_MS = 50

class AuthFrame {
  iframe = null
  
  create(src) {
    const el = document.createElement('iframe')

    el.style.visibility = 'hidden'
    el.style.position = 'absolute'
    el.style.width = el.style.height = '0'
    el.style.border = '0'
    el.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms')
    document.body.appendChild(el)
    el.src = src
    this.iframe = el
    return el
  }

  destroy() {
    document.body.removeChild(this.iframe)
  }

  monitorForHash() {
    return new Promise((resolve, reject) => {
      const nowMark = window.performance.now()
      const timeoutMark = nowMark + DEFAULT_IFRAME_TIMEOUT_MS
      let error
      const intervalId = setInterval(() => {
        if (window.performance.now() > timeoutMark || error) {
          this.destroy()
          clearInterval(intervalId)
          reject()
          return
        }
        
        let href
        const contentWindow = this.iframe.contentWindow
        try {
          // Will throw if cross origin, which should be caught and ignored
          href = contentWindow.location.href
        } catch (e) {
          error = e
        }
        
        if (!href || !href.length) {
          return
        }
        
        const contentHash = contentWindow.location?.hash || contentWindow.location?.search
        if (contentHash && contentHash.length) {
          this.destroy()
          clearInterval(intervalId)
          resolve(queryStringToObject(contentHash.substring(1)))
        }
      }, POLL_INTERVAL_MS)
    })
  }
}

export default AuthFrame
